import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../DrugDetails/Breadcrumb';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import _ from 'lodash';
import './index.scss';
import { Helmet } from 'react-helmet';
import '../../PressCenter/Articles/index.scss';
import { BLOCKS } from '@contentful/rich-text-types';
import {
  DRUG_CLASS_CTA,
  HOME_CANONICAL,
  MEDICALLY_REVIEWED_BY,
  WRITTEN_BY
} from '../../../constants/defaults';
import RelatedArticles from '../../common/RelatedArticles/index.jsx';
import AppPromoV1 from '../../common/AppPromoV1';
import PopularDrugs from '../../common/PopularDrugs';
import { fetchDrugClassRelatedBlogs } from '../../../services/Api/DrugInfo';
import {
  injectHorizontalAds,
  insertVerticalAds
} from '../../dfp/DynamicAdsInjection';
import {
  DRUG_CLASSES_PAGE_HORIZONTAL_ADS,
  DRUG_CLASSES_PAGE_VERTICAL_LEFT_SIDE_ADS,
  DRUG_CLASSES_PAGE_VERTICAL_RIGHT_SIDE_ADS,
  GPT_HEAD_DRUG_CLASSES_PAGE
} from '../../../constants/gptHeadTags/drugClassesPage.js';
import {
  AVERAGE_HORIZONTAL_AD_HEIGHT,
  AVERAGE_VERTICAL_AD_HEIGHT,
  BOTTOM_ANCHOR_AD_CONTAINER_ID,
  HORIZONTAL_ADS_CONTAINER_ID,
  MINIMUM_AD_SPACING,
  VERTICAL_ADS_CONTAINER_ID
} from '../../../constants/gptHeadTags/common.js';
import AdSlot from '../../dfp/AdSlot/index.js';
import FactCheckModal from '../../common/FactCheckModal';
import AuthorProfile from '../../common/AuthorProfile/index.js';
import KeyTakeawaysSection from '../../common/KeyTakeawaysSection/index.js';
import PublishedDate from '../../common/PublishedDate/index.js';
import TableOfContents from '../../common/TableOfContnents/index.js';
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);

const DrugClassDetail = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const content = JSON.parse(data && data.mainContent);
  const introContent = JSON.parse(data && data.introContent);
  const items = [
    { to: '/', label: 'Home' },
    { to: `/drug-classes`, label: `Drug classes` }
  ];
  const [blogData, setBlogData] = useState([]);
  const isAdsVisible = API.ALLOW_DRUG_CLASSES_PAGE_ADS;
  useEffect(() => {
    fetchDrugClassRelatedBlogs(data.slug, 12).then(res => {
      if (res) setBlogData(res.posts);
    });
  }, []);
  const renderOptions = links => {
    const entryBlockMap = new Map();

    if (links && !_.isEmpty(links.entries)) {
      for (const entry of links.entries.block) {
        entryBlockMap.set(entry.sys.id, entry);
      }
    }
    const assetBlockMap = new Map();
    if (links && !_.isEmpty(links.assets)) {
      for (const asset of links.assets.block) {
        assetBlockMap.set(asset.sys.id, asset);
      }
    }
    return {
      renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: node => {
          const entry = entryBlockMap.get(node.data.target.sys.id);
          return (
            <span
              dangerouslySetInnerHTML={{
                __html: entry.tableData
              }}
            ></span>
          );
        },
        [BLOCKS.EMBEDDED_ASSET]: node => {
          const asset = assetBlockMap.get(node.data.target.sys.id);
          return <img className="contentImg" src={asset.url} alt="" />;
        },
        [BLOCKS.HEADING_2]: node => {
          return (
            <h2 id={_.createIDFromHeader(node?.content[0]?.value)}>
              {node?.content[0]?.value}
            </h2>
          );
        },
        [BLOCKS.HEADING_3]: node => {
          return (
            <h3 id={_.createIDFromHeader(node?.content[0]?.value)}>
              {node?.content[0]?.value}
            </h3>
          );
        }
      }
    };
  };
  const getId = text => {
    let heading = text?.replace(/ /g, '-');
    //heading = heading?.replace(/\?/g, '');
    return heading?.replace(/\?/g, '')?.toLowerCase();
  };
  const getMetaData = () => {
    return (
      <Helmet>
        <title>{data && data.metaTitle}</title>
        <link
          rel="canonical"
          href={
            data && data.slug
              ? `${HOME_CANONICAL}/drug-classes/${data.slug}`
              : `${HOME_CANONICAL}/drug-classes/${props.location.pathname.toLocaleString()}`
          }
        />
        <meta name="description" content={data && data.metaDescription} />
        <meta property="og:type" content={data && data.ogType} />
        <meta property="og:title" content={data && data.ogTitle} />
        <meta property="og:description" content={data && data.ogDescription} />
        <meta property="og:image" content={data && data.ogImage} />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${props.location.pathname}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="aid_name" content={data.slug} />
        <meta property="placement_name" content="drug-classes" />

        {isAdsVisible && (
          <script async rel="preload">
            {GPT_HEAD_DRUG_CLASSES_PAGE}
          </script>
        )}
      </Helmet>
    );
  };
  const handleBottomAdScroll = () => {
    const viewportHeight = window.innerHeight;
    const bottomTriggerElement = document.querySelector('.homepage-footer');
    const anchorDiv = document.getElementById('bottomStickyAd');
    // Check if the user has scrolled at least 1.5 times the height of the viewport
    if (window.scrollY >= 1.5 * viewportHeight) {
      // Check if the footer is visible
      if (bottomTriggerElement.getBoundingClientRect().top <= viewportHeight) {
        // Show the anchor div
        anchorDiv.classList.remove('bottomAdsBanner');
      } else {
        // Hide the anchor div
        anchorDiv.classList.add('bottomAdsBanner');
      }
    } else {
      // Hide the anchor div
      anchorDiv.classList.remove('bottomAdsBanner');
    }
  };
  useEffect(() => {
    if (isAdsVisible) {
      const { sizeMapping } = window;
      const onSizeMappingLoad = () => {
        insertVerticalAds(
          DRUG_CLASSES_PAGE_VERTICAL_RIGHT_SIDE_ADS(sizeMapping.leftRight),
          `[data-ads-containter="${VERTICAL_ADS_CONTAINER_ID.DRUG_CLASSES_PAGE_RIGHT_SIDE}"]`,
          '#app',
          AVERAGE_VERTICAL_AD_HEIGHT,
          isAdsVisible
        );
        insertVerticalAds(
          DRUG_CLASSES_PAGE_VERTICAL_LEFT_SIDE_ADS(sizeMapping.leftRight),
          `[data-ads-containter="${VERTICAL_ADS_CONTAINER_ID.DRUG_CLASSES_PAGE_LEFT_SIDE}"]`,
          '#app',
          AVERAGE_VERTICAL_AD_HEIGHT,
          isAdsVisible
        );
        injectHorizontalAds(
          DRUG_CLASSES_PAGE_HORIZONTAL_ADS(sizeMapping.inContent),
          `[data-ads-containter="${HORIZONTAL_ADS_CONTAINER_ID.DRUG_CLASSES_PAGE_IN_CONTENT}"]`,
          '#app',
          AVERAGE_HORIZONTAL_AD_HEIGHT,
          isAdsVisible,
          MINIMUM_AD_SPACING
        );
      };
      if (typeof sizeMapping !== 'undefined') {
        if (sizeMapping.inContent) {
          onSizeMappingLoad();
        } else {
          const sizeMappingListener = () => {
            if (sizeMapping.inContent) {
              return onSizeMappingLoad();
            }
            return setTimeout(sizeMappingListener, 200);
          };
          sizeMappingListener();
        }
      }
      const anchorDiv = document.getElementById('bottomStickyAd');
      const viewportHeight = window.innerHeight;
      // Check if the total page is is at least 3X if the viewport height
      if (document.body.scrollHeight >= 3 * viewportHeight) {
        // Show the anchor div
        window.addEventListener(
          'scroll',
          _.throttle(handleBottomAdScroll, 250)
        );
      } else {
        anchorDiv.classList.remove('bottomAdsBanner');
      }
    }
    return () => {
      isAdsVisible &&
        window.removeEventListener('scroll', handleBottomAdScroll);
    };
  }, []);
  const displayAuthorProfile = (
    title = '',
    authorData = {},
    withDiscription = false
  ) => (
    <>
      {authorData?.name && (
        <AuthorProfile
          authorTitle={title}
          authorProfileLink={authorData?.reviewerPageOnSingleCare}
          authorDes={authorData?.title}
          authorName={authorData?.name}
          authorQualifications={authorData?.qualifications}
          authorImg={authorData?.photo}
          description={
            withDiscription
              ? documentToReactComponents(
                  JSON.parse(authorData?.biography || null)
                )
              : ''
          }
          className="userDataInfo"
        />
      )}
    </>
  );
  return (
    <div className="drugClassDetails">
      <div className="topBannerAds">
        <div className="adsInTopCenter">
          <AdSlot
            id="div-gpt-ad-1694721278359-0"
            featureDisplayAdsFlag={isAdsVisible}
          />
        </div>
      </div>
      <div className="mainContainer">
        <div
          className="leftAdsBannerContainer"
          data-ads-containter={
            VERTICAL_ADS_CONTAINER_ID.DRUG_CLASSES_PAGE_LEFT_SIDE
          }
        ></div>
        <div
          className="drugClassContiner"
          data-ads-containter={
            HORIZONTAL_ADS_CONTAINER_ID.DRUG_CLASSES_PAGE_IN_CONTENT
          }
        >
          <Breadcrumb items={items}>
            {items.map(({ to, label }) => (
              <a key={label} href={to}>
                {label}
              </a>
            ))}
            <span>{data.name}</span>
          </Breadcrumb>
          {getMetaData()}
          <h1>{data && data.h1Title}</h1>
          <div
            className={`${
              !_.isEmpty(data?.tableOfContents) ? 'updateBottomMargin' : ''
            }`}
          >
            {data && (
              <div className="authorLists topLists">
                <>
                  {!_.isEmpty(data?.medicalReviewer) &&
                    displayAuthorProfile(
                      MEDICALLY_REVIEWED_BY,
                      data?.medicalReviewer,
                      false
                    )}
                  {!_.isEmpty(data?.author) &&
                    displayAuthorProfile(WRITTEN_BY, data?.author, false)}
                </>
              </div>
            )}
            <PublishedDate
              publishedAt={data?.publishedAt}
              updatedAt={data?.lastUpdatedDate}
            >
              {(data?.medicalReviewer || data?.author) && <FactCheckModal />}
            </PublishedDate>
          </div>
          <section>
            {!_.isEmpty(data?.tableOfContents) && (
              <TableOfContents content={data?.tableOfContents} />
            )}
          </section>

          {!_.isEmpty(data && data?.keyTakeaways) && (
            <KeyTakeawaysSection
              keyTakeaways={JSON.parse(data?.keyTakeaways)}
            />
          )}
          <div className="mainDrugClassData">
            {documentToReactComponents(
              introContent && introContent.json,
              renderOptions(introContent && introContent.links)
            )}
          </div>
          <AppPromoV1 ctaLinks={DRUG_CLASS_CTA} />

          {!_.isEmpty(data && data.tableHeader) && (
            <h2 id={getId(data && data.tableHeader)} className="tableHead">
              {data && data.tableHeader}{' '}
            </h2>
          )}
          <table cellPadding="0" cellSpacing="0">
            <tr>
              <th>Drug name</th>
              <th>Learn more</th>
              <th>See SingleCare price</th>
            </tr>
            {data &&
              data.listOfDrugs.map((drug, index) => {
                return (
                  <tr className="dataTable" key={index}>
                    <td>{drug.name}</td>
                    <td>
                      <a href={`/prescription/${drug.seoName}/what-is`}>
                        {' '}
                        {`${drug.seoName}`}
                        &nbsp;<span>details</span>
                      </a>
                    </td>
                    <td>
                      <div className="separatorLine mobile-only">
                        <img
                          src="../content/images/icons/lineBottom.png"
                          alt=""
                        />
                      </div>
                      <a
                        className="seoDrugs"
                        href={`/prescription/${drug.seoName}`}
                      >
                        {drug.seoName}&nbsp;<span>price</span>
                      </a>
                    </td>
                  </tr>
                );
              })}
          </table>
          <div className="mainDrugClassData">
            {documentToReactComponents(
              content.json,
              renderOptions(content.links)
            )}
          </div>
          <section className="bottomUserDataInfo bottomInfo">
            {data && (
              <div className="authorLists">
                <>
                  {!_.isEmpty(data?.medicalReviewer) &&
                    displayAuthorProfile(
                      MEDICALLY_REVIEWED_BY,
                      data?.medicalReviewer,
                      true
                    )}
                  {!_.isEmpty(data?.author) &&
                    displayAuthorProfile(WRITTEN_BY, data?.author, true)}
                </>
              </div>
            )}
          </section>
          {!_.isEmpty(data && data.relatedDrugClasses) && (
            <section
              id="related-drugs"
              className="relatedDrugs mobile-section homepage-new"
            >
              <section className="top-drugs">
                <article>
                  <h4>{`Related Drugs Classes`}</h4>
                  <ul>
                    {data &&
                      data.relatedDrugClasses.map((item, id) => {
                        return (
                          <li key={id}>
                            <a href={`/drug-classes/${item.slug}`}>
                              {item.name}
                            </a>
                          </li>
                        );
                      })}
                  </ul>
                </article>
              </section>
            </section>
          )}
          {!_.isEmpty(blogData) && (
            <section className="homepage-new">
              <section id="news-research">
                <RelatedArticles
                  blogData={blogData}
                  drugName={data.name}
                  isRelatedArticle={true}
                />
              </section>
            </section>
          )}
          {!_.isEmpty(data && data.popularDrugs && data.popularDrugs.drugs) && (
            <PopularDrugs
              popularDrugs={data.popularDrugs.drugs}
              text="prices"
            />
          )}
        </div>
        <div
          className="rightAdsBannerContainer"
          data-ads-containter={
            VERTICAL_ADS_CONTAINER_ID.DRUG_CLASSES_PAGE_RIGHT_SIDE
          }
        ></div>
      </div>
      <div className="adsInCenter">
        <AdSlot
          id="div-gpt-ad-1698260592851-0"
          className="marginBottom-20"
          featureDisplayAdsFlag={isAdsVisible}
        />
      </div>
      <div
        id="bottomStickyAd"
        className="bottomLastAds"
        data-ads-container={BOTTOM_ANCHOR_AD_CONTAINER_ID.DRUG_CLASSES_PAGE}
      >
        <AdSlot
          id="div-gpt-ad-1698260625357-0"
          enableCloseBtn={true}
          innerDivClassName="p-1"
          featureDisplayAdsFlag={isAdsVisible}
        />
      </div>
    </div>
  );
};
export default DrugClassDetail;
